var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLedUserLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 5,
    fill: "#F9F9F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.523 32.814c-.518-.51-6.795-2.938-7.934-3.396-1.133-.45-1.585-1.697-1.585-1.697s-.51.282-.51-.51c0-.793.51.51 1.02-2.548 0 0 1.415-.397 1.134-3.68h-.34s.85-3.51 0-4.698c-.853-1.188-1.187-1.98-3.06-2.548-1.87-.567-1.19-.454-2.548-.396-1.36.057-2.492.793-2.492 1.188 0 0-.85.057-1.188.397-.34.34-.906 1.924-.906 2.32 0 .396.283 3.06.566 3.624l-.337.11c-.283 3.284 1.132 3.682 1.132 3.682.51 3.058 1.02 1.755 1.02 2.548 0 .792-.51.51-.51.51s-.453 1.246-1.585 1.697c-1.132.453-7.416 2.887-7.927 3.396-.51.52-.453 2.896-.453 2.896h12.036l.878-3.46-.78-.78 1.343-1.345 1.343 1.344-.78.78.878 3.46h12.036s.063-2.378-.453-2.897l.002.003z",
    fill: "#FFA700"
  })));
}
export default SvgLedUserLogo;